<template lang="pug">
  .schedule
    .schedule__content.page(:class="{ 'schedule__content--border-radius': !mobileMode }")
      h3.text-title Расписание

      schedule-calendar.schedule__calendar(
        ref="schedule-calendar"
        :events="events"
        :teachers="teachers"
        :groups="groups"
        :is-load="isLoad"
        :selectedDay="selectedDay"
        @selectDay="selectDay"
        @change="handleChange"
        @search="handleSearch"
      )
</template>

<script>
import { mapMutations, mapActions, mapState } from 'vuex';
import scheduleCalendar from '@/components/pages/Schedule/scheduleCalendar';

export default {
  components: {
    scheduleCalendar
  },
  computed: {
    ...mapState({
      teachers: state => state.schedule.teachers,
      groups: state => state.schedule.groups,
      isLoad: state => state.schedule.isLoad,
      events: state => state.schedule.events
    }),

    mobileMode() {
      return this.$store.state.mobileMode
    },

    selectedDay() {
      return this.$store.state.schedule.selectedDay;
    },
  },
  methods: {
    ...mapActions({
      getSchedule: 'schedule/getSchedule',
      getTeachers: 'schedule/getTeachers',
      getGroups: 'schedule/getGroups'
    }),

    ...mapMutations({
      setSelectedDay: 'schedule/setSelectedDay',
      setSchedule: 'schedule/setSchedule',
    }),

    handleSearch({ type, value }) {
      this[type === 'teacher' ? 'getTeachers' : 'getGroups'](value);
    },

    setFirstDayOfTheWeek() {
      this.setSelectedDay(this.$refs['schedule-calendar'].firstDayOfTheWeek);
    },

    selectDay(day) {
      this.setSelectedDay(day)
    },

    async handleChange(payload) {
      this.setSelectedDay(null);
      await this.getSchedule(payload);

      if (this.mobileMode) {
        this.setFirstDayOfTheWeek();
      }
    },
  },

  async created() {
    this.setSelectedDay(this.$moment())
    const dateStart = this.$moment().locale('ru').startOf('week').format('YYYY-MM-DD');
    const dateEnd = this.$moment().locale('ru').endOf('week').format('YYYY-MM-DD');

    await Promise.all([
      this.getSchedule({ dateStart, dateEnd  }),
      this.getTeachers(),
      this.getGroups()
    ])
  },

  beforeDestroy() {
    this.setSelectedDay(null);
    this.setSchedule([]);
  },
};
</script>

<style lang="scss">
.schedule {
  grid-template-areas: "main aside";
  overflow: hidden;
  height: 100%;

  &__calendar {
    max-width: 1000px;
    width: 100%;
    margin-right: auto;
  }

  .text-title {
    margin-bottom: 0.5rem;
  }

  .schedule__content {
    grid-area: main;
    border-radius: 2rem 0 0 0;
    height: 100%;
    overflow: auto;
    padding: 4rem 4rem 0 4rem;

    @include breakPoints(sm) {
      padding: 4rem 0 0;
    }
  }

  .schedule__content--border-radius {
    border-radius: 2rem 2rem 0 0;
  }

  .aside {
    grid-area: aside;
    transition-property: width;
    transition-duration: 0.3s;
    width: 0;
    grid-template-rows: 1fr;
  }

  .aside__body {
    position: relative;
    height: 100%;
  }

  .events-tab {
    position: absolute;
    width: 24.4rem;
    height: 100%;
    top: 2.4rem;
    left: 2.4rem;
  }

  .aside---show {
    width: 30rem;
  }
}
@include breakPoints(md) {
  .schedule {
    grid-auto-columns: 1fr;
    grid-template-rows: auto 1fr;
    grid-template-areas:
      "main"
      "aside";
    .text-title {
      display: none;
    }

    .aside {
      width: 100%;
      background-color: $basic-white;
      border-radius: 0;
    }

    .aside__body {
      width: 100%;
      padding-top: 0;
      .events-tab {
        padding: 1rem;
        overflow-y: auto;
        position: static;
        width: 100%;
        &::-webkit-scrollbar {
          width: 1rem;
        }
      }
    }

    .event__item {
      max-width: 35rem;
    }
  }
}
</style>
